import React from 'react'
import styled from 'styled-components'
import {
  headerWhiteStyle,
  header2WhiteStyle,
  magicContainerFullStyle,
  text2WhiteStyle,
} from '../styled'
import ButtonGetStarted from '../ButtonGetStarted'
import mediaQuery from 'styles/mediaQuery'

const Section = styled.section`
  ${magicContainerFullStyle};
  background-color: #191919;
  padding: 48px 24px;
  ${mediaQuery.bigTabletMin} {
    padding: 48px 24px;
  }
  ${mediaQuery.desktopMin} {
    padding: 48px 0;
  }
`

const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Title = styled.h2`
  ${headerWhiteStyle};
  margin-bottom: 24px;
  text-align: center;
`

const StepsContainer = styled.section`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 25px;
  ${mediaQuery.bigTabletMin} {
    width: 90%;
    flex-direction: row;
    justify-content: center;
  }
  ${mediaQuery.desktopMin} {
    width: 100%;
    margin-top: 50px;
  }
`
const StepStyle = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  box-sizing: content-box;
  & > span {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #191919;
    background-color: #faf9f6;
  }
  & > h3 {
    ${header2WhiteStyle};
    margin-top: 16px;
  }
  & > p {
    ${text2WhiteStyle};
    width: 100%;
    margin-top: 4px;
  }
  &:after {
    content: '';
    position: absolute;
    top: 26px;
    left: 11px;
    width: 1px;
    height: 100%;
    background-color: transparent;
    border-left: 1px dashed #faf9f6;
  }
  ${mediaQuery.mobile} {
    padding-bottom: 22px;
    &:last-child {
      padding-bottom: 0;
    }
  }
  ${mediaQuery.tabletMax} {
    padding-right: 90px;
    & > h3,
    & > p {
      padding-left: 32px;
    }
    &:last-child {
      padding-right: 0;
    }
  }
  ${mediaQuery.bigTabletMin} {
    width: 225px;
    padding-right: 170px;
    &:after {
      content: '';
      position: absolute;
      top: 10px;
      left: 24px;
      width: 100%;
      height: 1px;
      background-color: transparent;
      border-bottom: 1px dashed #faf9f6;
      border-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
  }
`

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 43px;
`

const translations = {
  header: 'How do you get started?',
  description:
    'MagicOs is a self-service e-commerce platform that allows brands to tap into the next generation shopping experience powered by shoppers. Apply to start selling your brand on Flip today.',
  buttonLabel: 'Get started',
}

const HomeHowGetStarted = () => {
  const steps = [
    {
      number: 1,
      header: 'Apply',
      description: 'Apply to join the exclusive list of brands on Flip',
    },
    {
      number: 2,
      header: 'Create account',
      description:
        'Once approved, create your account & link your online shop. Get live in under an hour.',
    },
    {
      number: 3,
      header: 'Start selling',
      description: 'Watch the magic happen',
    },
  ]

  return (
    <Section id="howGetStarted">
      <Wrapper>
        <Title>{translations.header}</Title>
        <StepsContainer>
          {steps.map(({ number, header, description }) => (
            <StepStyle key={number}>
              <span>{number}</span>
              <h3>{header}</h3>
              <p>{description}</p>
            </StepStyle>
          ))}
        </StepsContainer>
        <ButtonContainer>
          <ButtonGetStarted
            color="white"
            buttonLabel={translations.buttonLabel}
          />
        </ButtonContainer>
      </Wrapper>
    </Section>
  )
}

export default HomeHowGetStarted
